var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.separator)?_c('hr',{staticClass:"dropdown-divider"}):(!_vm.custom && !_vm.hasLink)?_c('a',{staticClass:"dropdown-item",class:_vm.anchorClasses,on:{"click":_vm.selectItem}},[_vm._t("default")],2):_c('div',{class:_vm.itemClasses,on:{"click":_vm.selectItem}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }